<script setup>
const props = defineProps({
  fillColor: { type: String, default: 'white' },
  strokeColor: { type: String, default: 'white' },
  filled: { type: Boolean, default: false },
})
</script>

<template>
  <svg
    v-if="!filled"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0306 8.31244H12.6627C13.0576 8.31244 13.3207 8.04925 13.3207 7.65441V5.02228C13.3207 4.62744 13.0576 4.36425 12.6627 4.36425H10.0306C9.63574 4.36425 9.37255 4.62744 9.37255 5.02228V5.68032H7.39846V2.39016C7.39846 1.99531 7.13527 1.73213 6.74043 1.73213H3.97669C3.7135 0.94244 2.98965 0.416061 2.13425 0.416061C1.01555 0.416061 0.160156 1.27146 0.160156 2.39016C0.160156 3.50886 1.01555 4.36425 2.13425 4.36425C2.98965 4.36425 3.7135 3.83787 3.97669 3.04819H6.08244V11.6026C6.08244 11.9974 6.34563 12.2606 6.74047 12.2606H9.3726V12.9187C9.3726 13.3135 9.63579 13.5767 10.0306 13.5767H12.6628C13.0576 13.5767 13.3208 13.3135 13.3208 12.9187V10.2865C13.3208 9.8917 13.0576 9.62851 12.6628 9.62851H10.0306C9.63579 9.62851 9.3726 9.8917 9.3726 10.2865V10.9446H7.39851V6.99638H9.3726V7.65441C9.3726 8.04925 9.63579 8.31244 10.0306 8.31244H10.0306ZM10.6886 5.68032H12.0047V6.99638H10.6886V5.68032ZM10.6886 10.9446H12.0047V12.2606H10.6886V10.9446Z"
      :fill="fillColor"
      :stroke="strokeColor"
      stroke-width="0.27"
    />
  </svg>
  <svg
    v-else
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66667 4.4362V2.76953M13.3333 4.4362V2.76953M4.16667 17.7695H15.8333C16.7538 17.7695 17.5 17.0233 17.5 16.1029V6.10286C17.5 5.18239 16.7538 4.4362 15.8333 4.4362H4.16667C3.24619 4.4362 2.5 5.18239 2.5 6.10286V16.1029C2.5 17.0233 3.24619 17.7695 4.16667 17.7695Z"
      :stroke="strokeColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.1493 11.8389H14.0449C14.3292 11.8389 14.5187 11.6494 14.5187 11.3651V9.4695C14.5187 9.18515 14.3292 8.99561 14.0449 8.99561H12.1493C11.865 8.99561 11.6754 9.18515 11.6754 9.4695V9.94339H10.2538V7.57395C10.2538 7.2896 10.0642 7.10006 9.77986 7.10006H7.78953C7.6 6.53136 7.0787 6.15228 6.46268 6.15228C5.65704 6.15228 5.04102 6.7683 5.04102 7.57395C5.04102 8.37959 5.65704 8.99561 6.46268 8.99561C7.0787 8.99561 7.6 8.61654 7.78953 8.04784H9.30601V14.2084C9.30601 14.4927 9.49555 14.6823 9.7799 14.6823H11.6755V15.1562C11.6755 15.4405 11.865 15.63 12.1493 15.63H14.0449C14.3292 15.63 14.5188 15.4405 14.5188 15.1562V13.2606C14.5188 12.9763 14.3292 12.7867 14.0449 12.7867H12.1493C11.865 12.7867 11.6755 12.9763 11.6755 13.2606V13.7345H10.2538V10.8912H11.6755V11.3651C11.6755 11.6494 11.865 11.8389 12.1493 11.8389H12.1493ZM12.6232 9.94339H13.571V10.8912H12.6232V9.94339ZM12.6232 13.7345H13.571V14.6823H12.6232V13.7345Z"
      :fill="fillColor"
      :stroke="strokeColor"
      stroke-width="0.27"
    />
  </svg>
</template>
